import { useEffect, useState } from 'react';
import { api_host } from '../common/globals/constants';
import { OBJECTIVES_ONLINE_DISPONIBILIDAD } from '../utils/storageNames';

function extractObjectivesUniqueList(objectivesList) {
  return [
    ...(objectivesList?.Uptime ?? []),
    ...(objectivesList?.Partial ?? []),
    ...(objectivesList?.Downtime ?? []),
    ...(objectivesList?.NoMonitoring ?? []),
  ];
}

export function useObjectivesList({ fromStorage }) {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  const getObjectivesFromStorage = (objectivesStorage) => {
    const objectivesStorageParse = objectivesStorage
      ? JSON.parse(objectivesStorage)
      : null;
    const objectivesUniqueList = extractObjectivesUniqueList(
      objectivesStorageParse
    );
    setData(objectivesUniqueList);
  };

  useEffect(() => {
    const objectivesStorage = sessionStorage.getItem(OBJECTIVES_ONLINE_DISPONIBILIDAD);
    if (fromStorage && objectivesStorage) {
      getObjectivesFromStorage(objectivesStorage);
      setIsLoading(false);
      return;
    }
    fetchObjectivesList();
  }, [fromStorage]);

  async function fetchObjectivesList() {
    try {
      setIsLoading(true);
      let token = sessionStorage.getItem('key');
      let user_id = sessionStorage.getItem('user');
      await fetch(
        `${api_host}/reporte/online/indicadores/ObjetivesUserList/?user=${user_id}&hash=5416d7cd6ef195a0f7622a9c56b55e84&token=${token}`
      )
        .then((response) => response.json())
        .then((myJson) => {
          sessionStorage.setItem(
            OBJECTIVES_ONLINE_DISPONIBILIDAD,
            JSON.stringify(myJson)
          );
          const objectivesUniqueList = extractObjectivesUniqueList(myJson);
          setData(objectivesUniqueList);
        });
    } catch (e) {
      console.error(e);
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  }

  return {
    data,
    isLoading,
    isError,
  };
}
